import styled, { DefaultTheme, keyframes, ThemeProps } from 'styled-components';
import colors from '../../helpers/colors';

export type SpinnerColor = string | ((props: ThemeProps<DefaultTheme>) => string);

export type SpinnerStyleProps = {
  strokeColor?: SpinnerColor;
};

/* All styling values except stroke color provided by an older spinner */
const spinnerAnimation = keyframes`
  0% {
    transform: rotate(240deg);
  }

  50% {
    transform: rotate(520deg);
  }

  100% {
    transform: rotate(600deg);
  }
`;

export const Container = styled.div`
  height: 32px;
  width: 32px;
`;

export const InnerContainer = styled(Container)`
  position: absolute;
`;

export const AnimatedSvg = styled.svg`
  stroke-dashoffset: 1870;
  stroke-dasharray: 2050;
  animation: ${spinnerAnimation} 0.8s linear infinite;
  transform-origin: 50% 50%;
  transition: opacity 0.3s ease;
`;

const spinnerStrokeWidth = '44px';

export const StyledCircle = styled.circle<SpinnerStyleProps>`
  fill: none;
  stroke: ${({ strokeColor }) => strokeColor ?? colors.core01};
  stroke-miterlimit: 10;
  stroke-width: ${spinnerStrokeWidth};
`;

export const BackgroundCircle = styled.circle<SpinnerStyleProps>`
  fill: none;
  /* The background circle is hidden by default but can be overriden in the theme */
  stroke: transparent;
  stroke-width: ${spinnerStrokeWidth};
`;
